export default __webpack_public_path__ + "static/media/team1.5399c741.png";